import React from "react";

/**
 * FieldGroup — a labelled group of controls that is not ONE control: a list of
 * rows, an image picker, a set of checkboxes. A `<fieldset>` with a `<legend>`,
 * because `FormField`'s `<label for>` can only name a single input, and pointed
 * at a group it names nothing.
 *
 * The legend matches `ui/Label`'s type so a group and a field read as siblings.
 */
const FieldGroup = ({ legend, hint, children }) => (
  <fieldset className="tw-m-0 tw-flex tw-min-w-0 tw-flex-col tw-gap-2 tw-border-0 tw-p-0">
    <legend className="tw-mb-0.5 tw-p-0 tw-text-[0.8125rem] tw-font-semibold tw-text-content">{legend}</legend>
    {hint && <p className="tw-m-0 tw-text-xs tw-leading-snug tw-text-content-subtle">{hint}</p>}
    {children}
  </fieldset>
);

export default FieldGroup;
